// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2iiDn","bigColWidth":"Table_bigColWidth__1Pibe","biggerColWidth":"Table_biggerColWidth__1pfo6","row":"Table_row__ta9dH","col":"Table_col__30GlX"};